import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Seo from "@/components/Seo";

const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo titleKey="seo.not_found_title" descKey="seo.not_found_desc" path="/404" />
      <section className="container-x py-32 text-center">
        <div className="text-6xl font-heading font-extrabold text-brand-green">404</div>
        <p className="mt-4 text-slate-600">{t("not_found.message")}</p>
        <Link to="/" className="btn-primary mt-6 inline-flex">{t("not_found.back_home")}</Link>
      </section>
    </>
  );
};

export default NotFoundPage;
